namespace MACRAIL {

export enum AlertClass {
    Primary = 'primary',
    Secondary = 'secondary',
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
}


/**
 * Create and show a modal dialog easily.
 */
export class Alert {

    private element: JQuery;

    private contentElement: JQuery;

    private oldContent: string;

    /**
     * Create a new ConfirmAlert
     *
     * @param element The alert div.
     */
    public constructor(element: JQuery | string) {
        this.element = $(element);

        this.contentElement = this.element.find('.alert-content');
    }

    /**
     * Set the content as text only.
     *
     * @param text New text content.
     *
     * @returns this
     */
    public setText(text: string) {
        this.contentElement.text(text);

        return this;
    }

    /**
     * Setthe content as HTML.
     *
     * @param html New HTML content.
     *
     * @returns this
     */
    public setHtml(html: string) {
        this.contentElement.html(html);

        return this;
    }

    /**
     * Set the class for this alert.
     *
     * Valid values are the bootstrap 'status' classes - info, warning, etc.
     *
     * @param className New class.
     *
     * @returns this
     */
    public setClass(className: AlertClass) {
        this.element.setAlertClass(className);

        return this;
    }

    /**
     * Show alert.
     *
     * @returns this
     */
    public show() {
        this.element.removeClass('hide');

        return this;
    }

    /**
     * Hide alert.
     *
     * @returns this
     */
    public hide() {
        this.element.addClass('hide');

        return this;
    }
}

}
